module.exports = __webpack_public_path__ + "static/media/27.d11e91ee.gif";